import {useCallback, useEffect, useState} from "react";

import {Post, TreeNode} from "../../../types/Post";
import {buildTreeFromFlat} from "../../../utils/category";
import {getCategories} from "../../../services/category";
import {getPosts} from "../api";

type UseContentManagementDataProps = {
  userToken: string;
};

export const useContentManagementData = ({userToken}: UseContentManagementDataProps) => {
  const [categories, setCategory] = useState<TreeNode[]>([]);
  const [posts, setPosts] = useState<Post[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const refresh = useCallback(async () => {
    try {
      setIsLoading(true);
      const categoryData = await getCategories();
      const postsData = await getPosts();
      const tempCategories = buildTreeFromFlat(categoryData);
      setCategory(tempCategories);
      setPosts(postsData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (userToken) {
      refresh();
    }
  }, [userToken, refresh]);

  return {
    categories,
    posts,
    isLoading,
    refresh,
  };
};
